<template>
  <div>
    <el-table
      :data="report.data"
      :default-sort="{ prop: order_column, order: order_type }"
      @sort-change="sort"
      class="w100"
      stripe
    >
      <el-table-column
        label="Artist"
        prop="sv_artist_name"
        sortable
      ></el-table-column>
      <el-table-column
        label="Track"
        prop="sv_track_name"
        sortable
      ></el-table-column>
      <el-table-column
        label="License"
        prop="sv_license_key"
        sortable
      ></el-table-column>
      <el-table-column
        label="Track balance"
        prop="track_campaign_balance"
        sortable
      ></el-table-column>
      <el-table-column
        label="Wallet balance"
        prop="user_wallet_balance"
        sortable
      ></el-table-column>
      <el-table-column
        label="VC paid"
        prop="vc_paid"
        sortable
      ></el-table-column>
      <el-table-column
        label="VC rate"
        prop="vc_rate"
        sortable
      ></el-table-column>
      <el-table-column
        width="200%"
        label="Video"
        prop="yt_video_title"
        sortable
      ></el-table-column>
      <el-table-column
        label="Category"
        prop="yt_category_name"
        sortable
      ></el-table-column>
      <el-table-column
        label="Views daily"
        prop="yt_views_daily"
        sortable
      ></el-table-column>
      <el-table-column
        width="180%"
        label="Views cumulative"
        prop="yt_views_cumm"
        sortable
      ></el-table-column>
      <el-table-column label="Created at" prop="created_at" sortable>
        <template slot-scope="props">
          {{ props.row.created_at | date }}
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="float-right"
      background
      @size-change="sizeChange"
      @current-change="currentChange"
      :current-page.sync="report.current_page"
      :page-sizes="[5, 10, 25, 50, 100]"
      :page-size="page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="report.total"
    ></el-pagination>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapState('vcTransactionHistory', [
      'report',
      'page',
      'page_size',
      'order_column',
      'order_type'
    ])
  },

  methods: {
    ...mapActions('vcTransactionHistory', ['read']),
    ...mapMutations('vcTransactionHistory', [
      'setPage',
      'setPageSize',
      'setOrdering'
    ]),

    sizeChange(page_size) {
      this.setPageSize(page_size)
      this.read()
    },
    currentChange(page) {
      this.setPage(page)
      this.read()
    },
    sort(d) {
      this.setOrdering({
        column: d.prop,
        type: this.ascDesc(d.order)
      })
      this.read()
    }
  },

  created() {
    this.read()
  }
}
</script>
